import actionTypes from '../constants/actionTypes';
import createFetchingHandlers from '../../../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../../../utils/createListReducer';

const {
  RECEIPT_RESET,
  RECEIPT_FETCH,
  RECEIPT_SUCCESS,
  RECEIPT_ERROR,
  RECEIPT_LINE_ADD_SUCCESS,
  RECEIPT_POSTING_FETCH,
  RECEIPT_POSTING_SUCCESS,
  RECEIPT_POSTING_ERROR,
  RECEIPT_CANCELLING_FETCH,
  RECEIPT_CANCELLING_SUCCESS,
  RECEIPT_CANCELLING_ERROR,
} = actionTypes;

const initialState = {
  data: {},
  metadata: {},
};

const fetchingData = createFetchingHandlers([RECEIPT_FETCH, RECEIPT_SUCCESS, RECEIPT_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [RECEIPT_SUCCESS]: (state, action) => {
    const { ID, document_no } = action.payload;
    return { ...state, data: { ID, document_no } };
  },
};

const addLineHandler = {
  [RECEIPT_LINE_ADD_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    if (!state?.data?.transactionId) {
      outputState.data = {
        ...outputState.data,
        ID: action.payload.data.transactionId,
      };
    }
    return outputState;
  },
};

const resetHandler = {
  [RECEIPT_RESET]: () => {
    return initialState;
  },
}

const posting = createFetchingHandlers([RECEIPT_POSTING_FETCH, RECEIPT_POSTING_SUCCESS, RECEIPT_POSTING_ERROR], () => ['metadata', 'posting']);
const cancelling = createFetchingHandlers([RECEIPT_CANCELLING_FETCH, RECEIPT_CANCELLING_SUCCESS, RECEIPT_CANCELLING_ERROR], () => ['metadata', 'cancelling']);

export default createListReducer(
  initialState,
  [fetchingData, resetHandler, addLineHandler, getDataHandler, posting, cancelling],
);
